<template>
  <div class="auth-wrapper d-flex align-items-center justify-content-center vh-100" style="background-color: #f0f2f5;">
    <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
      <transition-group name="slide-fade">
        <div v-for="alert in alerts" :key="alert.id" class="toast show align-items-center border-0 shadow-lg mb-2"
          :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
          <div class="d-flex p-3">
            <i :class="alert.icon" class="me-3 fs-5"></i>
            <div class="toast-body p-0 fw-medium">{{ alert.message }}</div>
            <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
          </div>
        </div>
      </transition-group>
    </div>
    <!-- Card Principal Dividido -->
    <div class="card border-0 shadow-lg rounded-4 overflow-hidden d-flex flex-column flex-md-row"
      style="width: 100%; max-width: 920px; min-height: 520px; background: #ffffff;">

      <!-- Coluna Esquerda: Marca / Slogan com AppLogoDoacao -->
      <div
        class="col-12 col-md-5 bg-light p-5 d-flex flex-column align-items-center justify-content-center text-center border-end bg-gradient-light">
        <div class="w-100">
          <AppLogoDoacao class="auth-logo" />
        </div>
        <p class="text-secondary px-2 mb-0" style="font-size: 0.95rem; line-height: 1.5;">
          Menos burocracia, mais eficiência: seus dados em um só lugar.
        </p>
      </div>

      <!-- Coluna Direita: Formulários Dinâmicos baseados nas Etapas -->
      <div class="col-12 col-md-7 p-4 p-md-5 d-flex flex-column justify-content-center bg-white">

        <!-- ETAPA 1: Informar E-mail -->
        <div v-if="step === 'email'">
          <div class="mb-4">
            <h3 class="fw-bold text-dark mb-1" style="font-size: 1.5rem;">Identificação</h3>
            <p class="text-secondary small">Informe seu e-mail para continuar.</p>
          </div>

          <form @submit.prevent="checkEmail">
            <div class="mb-4">
              <label class="form-label fw-bold text-secondary text-uppercase mb-2"
                style="font-size: 0.75rem; letter-spacing: 0.5px;">E-mail</label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0 text-muted"
                  style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                  <i class="bi bi-envelope"></i>
                </span>
                <input type="email" class="form-control form-control-pmg border-start-0" v-model="form.email"
                  placeholder="usuario@dominio.com" required autofocus>
              </div>
            </div>

            <button type="submit" class="btn btn-pmg-primary w-100 py-3 fw-bold shadow-sm" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              Continuar &nbsp;<i class="bi bi-arrow-right"></i>
            </button>
          </form>
        </div>

        <!-- ETAPA 2: Se o e-mail NÃO existe (Completar Cadastro Automático) -->
        <div v-if="step === 'register'">
          <div class="mb-4">
            <h3 class="fw-bold text-dark mb-1" style="font-size: 1.5rem;">Complete seu Cadastro</h3>
            <p class="text-secondary small">Não encontramos este e-mail. Por favor, preencha os dados abaixo.</p>
          </div>

          <form @submit.prevent="registerAndSendCode">
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary text-uppercase mb-2"
                style="font-size: 0.75rem; letter-spacing: 0.5px;">E-mail</label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0 text-muted"
                  style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                  <i class="bi bi-envelope"></i>
                </span>
                <input type="email" class="form-control form-control-pmg border-start-0 bg-light text-muted"
                  v-model="form.email" disabled>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label fw-bold text-secondary text-uppercase mb-2"
                style="font-size: 0.75rem; letter-spacing: 0.5px;">Nome Completo</label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0 text-muted"
                  style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                  <i class="bi bi-person"></i>
                </span>
                <input type="text" class="form-control form-control-pmg border-start-0" v-model="form.name"
                  placeholder="Seu nome" required>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold text-secondary text-uppercase mb-2"
                style="font-size: 0.75rem; letter-spacing: 0.5px;">CPF ou CNPJ</label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0 text-muted"
                  style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                  <i class="bi bi-card-text"></i>
                </span>
                <input type="text" class="form-control form-control-pmg border-start-0" v-model="form.document"
                  @input="applyDocumentMask" placeholder="000.000.000-00 ou 00.000.000/0000-00" required>
              </div>
            </div>

            <div class="mb-4">
              <label class="form-label fw-bold text-secondary text-uppercase mb-2"
                style="font-size: 0.75rem; letter-spacing: 0.5px;">Telefone / WhatsApp</label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0 text-muted"
                  style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                  <i class="bi bi-telephone"></i>
                </span>
                <input type="text" class="form-control form-control-pmg border-start-0" v-model="form.phone"
                  @input="applyPhoneMask" placeholder="(11) 90000-0000" required>
              </div>
            </div>
            <div class="form-check my-3 text-start">
              <input class="form-check-input" type="checkbox" id="termsCheck" v-model="acceptedTerms"
                style="cursor: pointer; width: 1.1em; height: 1.1em;">
              <label class="form-check-label small text-secondary cursor-pointer ms-1" for="termsCheck">
                Li e aceito os
                <a href="#" @click.prevent="openTermsModal" class="fw-bold text-decoration-underline"
                  style="color: #5F0487;">
                  Termos de Uso
                </a>
              </label>
            </div>
            <button class="btn w-100 text-white fw-bold py-2 rounded-3" style="background-color: #5F0487;"
              :disabled="!acceptedTerms || loading" @click="submitDonationStep">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              {{ loading ? 'Processando...' : 'Avançar e Enviar Código' }}
            </button>

            <button type="button" class="btn btn-link text-muted w-100 mt-2 text-decoration-none small text-center"
              @click="step = 'email'">Alterar e-mail</button>
          </form>
        </div>

        <!-- ETAPA 3: Validar Código OTP recebido por E-mail -->
        <div v-if="step === 'verify'">
          <div class="mb-4">
            <h3 class="fw-bold text-dark mb-1" style="font-size: 1.5rem;">Verificação de Acesso</h3>
            <p class="text-secondary small mb-0">Enviamos um código de 6 dígitos para <strong>{{ form.email }}</strong>
            </p>
          </div>

          <form @submit.prevent="verifyCode">
            <div class="mb-4">
              <label class="form-label fw-bold text-secondary text-uppercase mb-2"
                style="font-size: 0.75rem; letter-spacing: 0.5px;">Código de Verificação</label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0 text-muted"
                  style="border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
                  <i class="bi bi-shield-lock"></i>
                </span>
                <input type="text"
                  class="form-control form-control-pmg border-start-0 text-center fw-bold fs-4 font-monospace"
                  v-model="form.code" @input="applyCodeMask" placeholder="000000" maxlength="6" required autofocus>
              </div>
            </div>

            <button type="submit" class="btn btn-pmg-primary w-100 py-3 fw-bold shadow-sm"
              :disabled="loading || form.code.length < 6">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              Confirmar e Entrar
            </button>

            <div class="d-flex justify-content-between align-items-center mt-3 small">
              <a href="#" class="text-muted text-decoration-none" @click.prevent="step = 'email'">Alterar e-mail</a>
              <a href="#" class="text-decoration-none fw-bold" style="color: #5F0487;"
                @click.prevent="checkEmail">Reenviar código</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="termsOfUseModal" tabindex="-1" aria-hidden="true" ref="termsOfUseModal">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content border-0 shadow-lg rounded-4">
        <div class="modal-header border-0 pt-4 px-4 pb-2">
          <h5 class="fw-bold m-0 text-dark d-flex align-items-center gap-2">
            <i class="bi bi-file-text" style="color: #5F0487;"></i> Termos de Uso da Plataforma
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-4">
          <!-- Injeção dos Termos -->
          <div class="terms-content text-secondary small" style="text-align: justify; line-height: 1.6;">
            <p>Bem-vindo ao <strong>Dailypag Doação</strong>. Ao utilizar nossa plataforma para criar campanhas de
              arrecadação, você concorda integralmente com as regras e condições descritas abaixo.</p>

            <h6 class="fw-bold text-dark mt-4 mb-2">1. Política de Privacidade e Proteção de Dados (LGPD)</h6>
            <p>Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), garantimos que seus dados
              pessoais (nome, CPF, e-mail, telefone e dados bancários) são coletados exclusivamente para fins de
              verificação de identidade, processamento de pagamentos, prevenção à fraude e cumprimento de obrigações
              legais. Não comercializamos suas informações com terceiros.</p>

            <h6 class="fw-bold text-dark mt-4 mb-2">2. Regras e Condições para Saques</h6>
            <p>Para garantir a segurança das transações e evitar fraudes financeiras, o processo de repasse dos valores
              arrecadados obedece estritamente às seguintes regras:</p>
            <ul class="mb-3 text-secondary">
              <li class="mb-1"><strong>Titularidade Obrigatória:</strong> Os saques só serão aprovados e transferidos
                para contas bancárias ou chaves PIX que possuam a <strong>exata mesma titularidade (mesmo
                  CPF/CNPJ)</strong> do usuário cadastrado como criador da página de arrecadação. Transferências para
                contas de terceiros são expressamente proibidas.</li>
              <li class="mb-1"><strong>Valor Mínimo:</strong> O valor mínimo exigido para a solicitação de qualquer
                saque na plataforma é de <strong>R$ 10,00</strong> (dez reais).</li>
              <li class="mb-1"><strong>Prazo de Processamento:</strong> Uma vez solicitado no painel, o repasse
                financeiro será analisado e creditado na conta do usuário no prazo de <strong>2 a 3 dias úteis</strong>.
              </li>
            </ul>

            <h6 class="fw-bold text-dark mt-4 mb-2">3. Responsabilidade das Campanhas e Conduta</h6>
            <p>A responsabilidade pela veracidade das informações e pela destinação real dos recursos arrecadados é
              exclusiva do criador da campanha. O Dailypag Doação atua apenas como intermediador tecnológico e
              financeiro. É proibido criar campanhas para fins ilícitos ou enganosos.</p>

            <h6 class="fw-bold text-dark mt-4 mb-2">4. Taxas de Processamento e Transação</h6>
            <p>Para garantir a segurança e a infraestrutura tecnológica das doações, incidem taxas operacionais sobre o
              valor arrecadado, destinadas a cobrir custos bancários e manutenção do sistema.</p>

            <h6 class="fw-bold text-dark mt-4 mb-2">5. Penalidades e Banimento da Plataforma</h6>
            <p>O descumprimento de qualquer uma das regras estabelecidas nestes Termos de Uso, bem como a suspeita de
              fraude, falsidade ideológica ou violação de direitos, acarretará no <strong>banimento imediato e
                definitivo do usuário da plataforma</strong>. Nestes casos, os fundos poderão ser retidos para devolução
              aos doadores originais.</p>
          </div>
        </div>

        <div class="modal-footer border-0 p-3 bg-light rounded-bottom-4">
          <button type="button" class="btn w-100 text-white fw-bold rounded-3 py-2" style="background-color: #5F0487;"
            @click="acceptTermsFromModal">
            Li e Concordo com os Termos
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import AppLogoDoacao from '@/components/AppLogoDoacao.vue';

export default {
  name: 'AuthView',
  components: {
    AppLogoDoacao
  },
  data() {
    return {
      step: 'email',
      loading: false,
      alerts: [],
      form: {
        email: '',
        name: '',
        document: '',
        phone: '',
        code: ''
      },
      acceptedTerms: false,
      termsModalInstance: null,
    }
  },
  mounted() {
    // Instancia o modal do Bootstrap
    const modalEl = document.getElementById('termsOfUseModal');
    if (modalEl) {
      this.termsModalInstance = new window.bootstrap.Modal(modalEl);
    }
  },
  computed: {
    isRegisterInvalid() {
      return !this.form.name.trim() || !this.form.document.trim() || !this.form.phone.trim();
    }
  },
  methods: {
    // ----------------------------------------------------
    // MÁSCARAS NATIVAS (SEM LIBS EXTERNAS)
    // ----------------------------------------------------
    applyDocumentMask(event) {
      let v = event.target.value.replace(/\D/g, ""); // Remove tudo que não é número
      if (v.length > 14) v = v.substring(0, 14); // Limita a 14 dígitos numéricos (CNPJ)

      if (v.length <= 11) {
        // Formato CPF: 000.000.000-00
        v = v.replace(/(\d{3})(\d)/, "$1.$2");
        v = v.replace(/(\d{3})(\d)/, "$1.$2");
        v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      } else {
        // Formato CNPJ: 00.000.000/0000-00
        v = v.replace(/^(\d{2})(\d)/, "$1.$2");
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
        v = v.replace(/(\d{4})(\d)/, "$1-$2");
      }
      this.form.document = v;
    },

    applyPhoneMask(event) {
      let v = event.target.value.replace(/\D/g, ""); // Remove tudo que não é número
      if (v.length > 11) v = v.substring(0, 11); // Limita a 11 dígitos numéricos

      if (v.length <= 10) {
        // Telefone Fixo: (00) 0000-0000
        v = v.replace(/(\d{2})(\d)/, "($1) $2");
        v = v.replace(/(\d{4})(\d)/, "$1-$2");
      } else {
        // Celular: (00) 00000-0000
        v = v.replace(/(\d{2})(\d)/, "($1) $2");
        v = v.replace(/(\d{5})(\d)/, "$1-$2");
      }
      this.form.phone = v;
    },

    // ----------------------------------------------------
    // LÓGICA DE REQUISIÇÕES (API)
    // ----------------------------------------------------
    async checkEmail() {
      this.loading = true;
      try {
        await api.post('/client-jwt/auth/request-code', { email: this.form.email });
        this.step = 'verify';
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.step = 'register';
        } else {
          console.error("Erro na verificação do e-mail:", error);
          this.showAlert("Ocorreu um erro ao comunicar com o servidor. Tente novamente.");
        }
      } finally {
        this.loading = false;
      }
    },

    async registerAndSendCode() {
      this.loading = true;
      try {
        await api.post('/client-jwt/auth/register', {
          email: this.form.email,
          name: this.form.name,
          document: this.form.document.replace(/\D/g, ''),
          phone: this.form.phone.replace(/\D/g, '')
        });

        this.step = 'verify';

      } catch (error) {
        console.error("Erro no cadastro:", error);
        this.showAlert("Não foi possível realizar o cadastro no momento. Tente novamente.");
      } finally {
        this.loading = false;
      }
    },

    async verifyCode() {
      this.loading = true;
      try {
        const response = await api.post('/client-jwt/auth/verify-code', {
          email: this.form.email,
          code: this.form.code
        });
        const token = response.data.token || 'mock-jwt-token-123456';
        localStorage.setItem('auth_token', token);
        localStorage.setItem('name', response.data.name);
        localStorage.setItem('email', response.data.email);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        this.$router.push('/dashboard');

      } catch (error) {
        console.error("Código inválido", error);
        this.showAlert("O código inserido está incorreto ou já expirou.");
      } finally {
        this.loading = false;
      }
    },
    showAlert(message, type = 'danger', icon = 'bi-exclamation-triangle-fill') {
      const id = Date.now();
      this.alerts.push({ id, message, type, icon });
      setTimeout(() => this.removeAlert(id), 5000); // Some após 5 segundos
    },
    removeAlert(id) {
      this.alerts = this.alerts.filter(alert => alert.id !== id);
    },
    applyCodeMask(event) {
      // Remove qualquer caractere que não seja número
      let v = event.target.value.replace(/\D/g, "");

      // Garante que não passe de 6 dígitos
      if (v.length > 6) {
        v = v.substring(0, 6);
      }

      this.form.code = v;
    },

    openTermsModal() {
      if (this.termsModalInstance) {
        this.termsModalInstance.show();
      }
    },
    acceptTermsFromModal() {
      this.acceptedTerms = true;
      if (this.termsModalInstance) {
        this.termsModalInstance.hide();
      }
    }
  }
}
</script>

<style scoped>
.auth-logo :deep(.logo-image) {
  margin-bottom: 25px;
  height: 100px !important;
}

.form-control-pmg {
  border-radius: 0 12px 12px 0 !important;
  border: 1px solid #cbd5e1 !important;
  padding: 12px 16px;
  font-size: 0.95rem;
}

.form-control-pmg:focus {
  border-color: #5F0487 !important;
  box-shadow: 0 0 0 3px rgba(95, 4, 135, 0.1) !important;
}

.btn-pmg-primary {
  background: #5F0487;
  color: #fff;
  border-radius: 12px !important;
  border: none;
  transition: all 0.3s ease;
}

.btn-pmg-primary:hover {
  background: #4a036a;
}

/* Animações das Notificações (Toasts) */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>